import PropTypes from 'prop-types'
import React from 'react'
import Svg from 'components/util/Svg'
import styles from './_performanceMetric.css'
import FormattedGoal from './FormattedGoal'

import {
  GOAL_TYPES,
} from '../shared/constants'

export default function PerformanceMetric (props) {
  const { goalType, value } = props

  const goalMeta = Object.keys(GOAL_TYPES).map((goal) => {
    return GOAL_TYPES[goal]
  }).filter((type) => type.key === goalType)[0]

  return (
    <div className={styles.metricContainer}>
      <Svg className={styles.metricIcon} name={goalMeta.icon} />
      <div className={styles.metricLabel}>
        {goalMeta.label}
      </div>
      <div className={styles.metricValue}>
        <FormattedGoal
          goalType={goalType}
          value={value} />
      </div>
    </div>
  )
}

PerformanceMetric.propTypes = {
  goalType: PropTypes.string,
  value: PropTypes.number,
}



// WEBPACK FOOTER //
// ./src/components/goals/view/PerformanceMetric.jsx